import stringify from'json-stable-stringify';export function dataRefIdDecorator(prefix,locator){return"".concat(prefix,"_").concat(stringify(locator));}